module.exports = __webpack_public_path__ + "static/media/pandas.42e9a1f3.png";